export default __webpack_public_path__ + "static/media/no_register.67f66014.png";